export const sectionDetailsSample = {
  _id: "84ds57a4d1d8e6f4sd4fd45798",
  sectionId: "15655",
  sectionTitle: "Environment",
  subSections: [
    {
      _id: "84ds57a4d1d8e6f4sd4fd45788",
      SubSectionId: "15654",
      SubSectionTitle: "GHG Emission",
    },
    {
      _id: "84ds57a4d1d8e6f4sd4fd45798",
      SubSectionId: "15655",
      SubSectionTitle: "Air Emission",
    },
  ],
};
